/**
 * Ayarlar › Depolama › "Değişiklikte otomatik indir" (gelen karar 03.11.2026).
 *
 * Bulut depolama bağlıyken anahtar kapalı ve açılamaz. Sorumluluk metni
 * (kullanıcı kararı 03.11.2026) her zaman görünür: tarayıcı engellenen bir
 * indirmeyi sayfaya söylemez, indirme hataları bildirilemeyebilir; dosyaları
 * denetlemek ve cihaz dışında saklamak kullanıcıdadır. Bir anormallik değil,
 * kalıcı bir bilgi: uyarı rengi almaz (CLAUDE.md §6).
 */

import { M, YEREL } from "../dil";
import { BEKLEME_SECENEKLERI_SN } from "../lib/otoIndir";
import { useMutation } from "../repo/useAsync";
import { Button, Field, InlineError, Notice, Select } from "../ui/primitives";
import { useOtoIndir } from "../yedek/OtoIndirSaglayici";

function sureEtiketi(sn: number): string {
  return sn < 60 ? M.yedek.otoIndir.saniye(sn) : M.yedek.otoIndir.dakika(sn / 60);
}

export function OtomatikIndirmeBolumu() {
  const o = useOtoIndir();
  const run = useMutation();
  if (o === null || o.acik === null) return null;
  const T = M.yedek.otoIndir;
  const acik = o.acik && !o.bulutBagli;

  return (
    <div className="mt-4 border-t border-line pt-3" data-testid="oto-indir">
      <h3 className="text-[13px] font-semibold text-ink">{T.baslik}</h3>
      <p className="mt-1 text-[12px] text-muted">{o.bulutBagli ? T.bulutBagli : T.aciklama}</p>
      <label className="mt-2 flex items-center gap-2 text-[13px] text-ink">
        <input
          type="checkbox"
          checked={acik}
          disabled={o.bulutBagli || run.pending}
          onChange={(e) => {
            const v = e.currentTarget.checked;
            void run.run(() => o.acikYap(v));
          }}
        />
        {T.baslik}
      </label>
      {!o.bulutBagli && (
        <>
          <div className="mt-2 max-w-[16rem]">
            <Field label={T.bekleme} htmlFor="oto-indir-bekleme">
              <Select
                id="oto-indir-bekleme"
                value={String(o.beklemeSn)}
                disabled={!acik || run.pending}
                options={BEKLEME_SECENEKLERI_SN.map((sn) => ({ value: String(sn), label: sureEtiketi(sn) }))}
                onChange={(e) => {
                  const sn = Number(e.currentTarget.value);
                  void run.run(() => o.beklemeYap(sn));
                }}
              />
            </Field>
          </div>
          <p className="mt-2 text-[12px] text-muted">
            {o.son === null
              ? T.sonIndirmeYok
              : T.sonIndirme(o.son.dosya, new Date(o.son.zaman).toLocaleString(YEREL, { dateStyle: "short", timeStyle: "medium" }))}
          </p>
          {acik && o.izin === "hayir" && (
            <p className="mt-1 text-[12px] text-muted">
              {T.izinYok}{" "}
              <Button className="!py-0.5 text-[12px]" onClick={() => o.izniSifirla()}>
                {T.yenidenDene}
              </Button>
            </p>
          )}
          <div className="mt-2">
            <Button disabled={run.pending} onClick={() => void run.run(() => o.indir())}>
              {T.simdiIndir}
            </Button>
          </div>
          <InlineError error={run.error ?? o.hata} />
          <div className="mt-3">
            <Notice tone="info" title={T.uyariBaslik}>
              <p>{T.uyari1}</p>
              <p>{T.uyari2}</p>
            </Notice>
          </div>
          <p className="mt-2 text-[12px] text-faint">{T.geriYukleme}</p>
        </>
      )}
    </div>
  );
}
